import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { fetchAdvertsList, fetchAddOrEditAdvertSubmission } from 'modules/adverts/actions';
import { campaignStatusEnum } from 'modules/campaigns/enums';
import AdvertsComponent from 'modules/adverts/components/AdvertsComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AdvertsContainer = ({ advertsListApiCallBody }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [showCopiedTextOverlay, setShowCopiedTextOverlay] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPageFilter, setSelectedPageFilter] = useState(1);
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
  const [isActionPopupLoading, setIsActionPopupLoading] = useState(false);
  const [actionPopupStatus, setActionPopupStatus] = useState(0);
  const [actionPopupTarget, setActionPopupTarget] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // eslint-disable-next-line no-unused-vars
  const submitSearchQuery = reset => {
    // setSelectedPageFilter(1);
    // const body = {
    //   ...ordersApiCallParams,
    // };
    // if (searchQuery) body.searchTerm = searchQuery;
    // if (reset) delete body.searchTerm;
    // setOrdersApiCallParams(body);
    // dispatch(fetchAllOrders(body));
  };

  const reloadAdvertsPage = () => {
    const body = {
      data: advertsListApiCallBody,
    };

    dispatch(fetchAdvertsList(body));
  };

  const actionPopupConfirmBtnCallback = shouldReloadOrderDetails => {
    setIsActionPopupOpen(false);
    setIsActionPopupLoading(false);
    setActionPopupStatus(0);
    setActionPopupTarget('');

    if (shouldReloadOrderDetails) reloadAdvertsPage();
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextToCopyToClipboardClick = textToCopy => {
    navigator.clipboard.writeText(textToCopy);
    setShowCopiedTextOverlay(true);

    setTimeout(() => {
      setShowCopiedTextOverlay(false);
    }, 1000);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        submitSearchQuery();
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      submitSearchQuery(true);
  };

  const handleOrderPaginationClick = selectedPageNumber => {
    setSelectedPageFilter(selectedPageNumber);

    const data = {
      ...advertsListApiCallBody,
    };
    data.page = selectedPageNumber;
    const body = {
      data,
    };

    dispatch(fetchAdvertsList(body));
  };

  const handleActionBtnClick = (advertKey, actionStatus) => {
    setIsActionPopupOpen(true);
    setActionPopupStatus(actionStatus);
    setActionPopupTarget(advertKey);
  };

  const handleActionPopupConfirmBtnClick = () => {
    setIsActionPopupLoading(true);

    const body = {
      data: {
        status: campaignStatusEnum.getKeyByValue(actionPopupStatus),
      },
      advertKey: actionPopupTarget,
      actionPopupCallbackAction: actionPopupConfirmBtnCallback,
    };

    dispatch(fetchAddOrEditAdvertSubmission(body));
  };

  const handleActionPopupDismissBtnClick = () => {
    setIsActionPopupOpen(false);
    setActionPopupStatus(0);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AdvertsComponent
      showCopiedTextOverlay={showCopiedTextOverlay}
      searchQuery={searchQuery}
      selectedPageFilter={selectedPageFilter}
      isActionPopupOpen={isActionPopupOpen}
      isActionPopupLoading={isActionPopupLoading}
      actionPopupStatus={actionPopupStatus}
      handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
      handleSearchBarInputChange={handleSearchBarInputChange}
      handleOrderPaginationClick={handleOrderPaginationClick}
      handleActionBtnClick={handleActionBtnClick}
      handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
      handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AdvertsContainer.propTypes = {
  advertsListApiCallBody: PropTypes.shape({}).isRequired,
};

AdvertsContainer.defaultProps = {};

export default AdvertsContainer;
